import { render, staticRenderFns } from "./syddk.vue?vue&type=template&id=ac4719da"
import script from "./syddk.vue?vue&type=script&lang=js"
export * from "./syddk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports